import { render } from "./DefButtonSecondary.vue?vue&type=template&id=f94e12c8&scoped=true"
import script from "./DefButtonSecondary.vue?vue&type=script&lang=js"
export * from "./DefButtonSecondary.vue?vue&type=script&lang=js"

import "./DefButtonSecondary.vue?vue&type=style&index=0&id=f94e12c8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f94e12c8"]])

export default __exports__